import trackPurchase from './track-purchase'
import trackViewItem from './track-view-item'
import trackAddToCart from './track-add-to-cart'
import trackBeginCheckout from './track-begin-checkout'
import trackAddPaymentInfo from './track-add-payment-info'

export default {
    trackPurchase,
    trackViewItem,
    trackAddToCart,
    trackBeginCheckout,
    trackAddPaymentInfo,
}
